const screenSizes = [
  {
    label: 'Phone',
    options: [
      {
        width: 384,
        height: 854,
        label: 'Small (384x854)'
      },
      {
        width: 414,
        height: 736,
        label: 'Medium (414x736)'
      },
      {
        width: 412,
        height: 919,
        label: 'Large (412x919)'
      }
    ]
  },
  {
    label: 'Tablet',
    options: [
      {
        width: 768,
        height: 1024,
        label: 'Small (768x1024)'
      },
      {
        width: 834,
        height: 1194,
        label: 'Medium (834x1194)'
      },
      {
        width: 1024,
        height: 1366,
        label: 'Large (1024x1366)'
      }
    ]
  }
]

export { screenSizes }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/ScreeenSizes.js